import { ReportsRepository } from '@/modules/ctx-documents/adapter/ReportsRepository';
import { ReImportSpecification } from '@/clients/dashboardapi/v2';
import ReImportSpecificationUtils from '@/assets/js/utils/ReImportSpecificationUtils';
import { ReImportSpecsWithReferenceDate } from '@/modules/shared/types/ReImportSpecsWithReferenceDate';
import type { DocumentsRepository } from '@/modules/ctx-documents';

export class ReportService {
    private readonly reportsRepository: ReportsRepository;
    private readonly documentsRepository: DocumentsRepository;

    constructor(params: {
        reportsRepository: ReportsRepository;
        documentsRepository: DocumentsRepository;
    }) {
        this.reportsRepository = params.reportsRepository;
        this.documentsRepository = params.documentsRepository;
    }

    public async retryReport(documentKey: string, reImportSpecifications?: ReImportSpecification[]) {
        return await this.reportsRepository.retryReport({ documentKey, reImportSpecifications });
    }

    public async getAffectedReImportSpecifications(documentKeys: string[]): Promise<Map<string, ReImportSpecsWithReferenceDate>> {
        if (documentKeys.length === 0) {
            return new Map<string, ReImportSpecsWithReferenceDate>();
        }

        const affectedReImportSpecs = await this.reportsRepository.getAffectedReImportSpecifications(documentKeys);

        const affectedReImportSpecsWithReferenceDate = new Map<string, ReImportSpecsWithReferenceDate>();

        for (const [key, specs] of Object.entries(affectedReImportSpecs)) {
            const document = await this.documentsRepository.getDocumentByKey(key);
            affectedReImportSpecsWithReferenceDate.set(key, { specs, referenceDate: document.contentDate });
        }

        return ReImportSpecificationUtils.resolveReImportSpecifications(affectedReImportSpecsWithReferenceDate);
    }
}
